module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAArUlEQVR42rSVSwqEMAxAA14zOVjXleklB2rVFMqg0/wayEbNe0WSFOCOrWVuieALZM4GA/jTsrb8OgTI9ZV5lyDzg+oQjOCeJxfo4YVGgC/11D+wCqZgq0AM1grUYKnADJ4Jkhf8T1AjwBKBC9wjvcATBOyKJSfHVf8cV3XLrI/JKpAOiFqgnTzyLi0yTjJ5waL6HNBeT4K936ElYDBGQfm9pPeAXUHMucCHAAMANKXU59Qv66oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/menu_close.png
// module id = 263
// module chunks = 1